import { Component, OnDestroy } from '@angular/core';
import { WholesalerPharmacyService } from '../services';
import { UserUtils } from 'src/app/shared';
import { ICON_TYPE } from '@spartacus/storefront';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomB2BUnit, USER_TYPE } from 'src/app/shared/model';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { map } from 'rxjs';

@Component({
  selector: 'app-wholesaler-pharmacy-selector',
  templateUrl: './wholesaler-pharmacy-selector.component.html',
  styleUrls: ['./wholesaler-pharmacy-selector.component.scss'],
})
export class WholesalerPharmacySelectorComponent implements OnDestroy {
  constructor(
    protected wholesalerPharmacyService: WholesalerPharmacyService,
    protected user: UserAccountFacade,
    protected modalService: NgbModal
  ) {}

  iconTypes = ICON_TYPE;
  userTypes = USER_TYPE;
  currentlySelected: CustomB2BUnit;

  userType$ = this.user
    .get()
    .pipe(
      map((user) =>
        UserUtils.isPharmacyUser(user) ? USER_TYPE.PHARMACY : USER_TYPE.NBP
      )
    );
  searchResults$ = this.wholesalerPharmacyService.searchResults$;
  defaultSelected$ =
    this.wholesalerPharmacyService.getDefaultWholesalerPharmacy();

  select(selected: CustomB2BUnit): void {
    this.currentlySelected = selected;
  }

  confirmSelection(userType: USER_TYPE): void {
    if (userType === USER_TYPE.PHARMACY) {
      this.wholesalerPharmacyService.setDefaultWholesaler(
        this.currentlySelected
      );
    } else {
      this.wholesalerPharmacyService.setDefaultPharmacy(this.currentlySelected);
    }
    this.modalService.dismissAll('confirm');
  }

  close(): void {
    this.modalService.dismissAll();
  }

  ngOnDestroy(): void {
    this.wholesalerPharmacyService.resetSearchResults();
  }
}
